var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-datasource-control" }, [
    _vm.type === "TRENDING"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _c("dt", [
            _c("i", { staticClass: "go-icon-24 go-icon-home" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("scrap-agent.youtube.trending"))),
            ]),
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "trendingSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    return _vm.change(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "trendingSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "MY_SUBSCRIPTION"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _c("dt", [
            _c("i", { staticClass: "go-icon-24 go-icon-home" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("scrap-agent.youtube.my-sub")))]),
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "mySubscriptionSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    return _vm.change(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "mySubscriptionSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "MY_CHANNEL"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _c("dt", [
            _c("i", { staticClass: "go-icon-24 go-icon-home" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("scrap-agent.youtube.my-channel"))),
            ]),
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "myChannelSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    return _vm.change(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "myChannelSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "INBOX"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "inboxSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    return _vm.change(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "inboxSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "EVERY_THING"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _c("dt", [
            _c("i", { staticClass: "go-icon-24 go-icon-home" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("scrap-agent.allow-access.everything"))),
            ]),
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "everythingSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    _vm.change(event.target.checked)
                    _vm.updateEverything(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "everythingSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "MY_PROFILE"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _c("dt", [
            _c("i", { staticClass: "go-icon-24 go-icon-home" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("scrap-agent.twitter.profile")))]),
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "myProfileSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    return _vm.change(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "myProfileSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "NEW_FEED"
      ? _c("dl", { staticClass: "go-block-between" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "custom-control custom-switch" }, [
              _c("input", {
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "newFeedSwitch" },
                domProps: { checked: _vm.value },
                on: {
                  change: function (event) {
                    return _vm.change(event.target.checked)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", {
                staticClass: "custom-control-label",
                attrs: { for: "newFeedSwitch" },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "DATA_TYPE"
      ? _c(
          "dl",
          { staticClass: "go-block-between" },
          [
            _c("dt", [
              _c("i", { staticClass: "go-icon-24 go-icon-home" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("scrap-agent.allow-access.datatype"))),
              ]),
            ]),
            _vm._v(" "),
            _c("MultiSelect", {
              attrs: {
                value: _vm.value,
                options: _vm.options,
                disable: _vm.disabled,
                placeholder: _vm.$t("scrap-agent.allow-access.select-datatype"),
              },
              on: { input: _vm.change },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "PROFILE"
      ? _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "go-block-between" }, [
            _c("label", { staticClass: "go-form-label" }, [
              _vm._v(_vm._s(_vm.$t("scrap-agent.twitter.input-profile"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-input-multiple" },
            _vm._l(_vm.value, function (_, index) {
              return _c("div", { key: index, staticClass: "go-input-group" }, [
                _c("input", {
                  staticClass: "go-form-control",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("scrap-agent.twitter.placeholder"),
                  },
                  domProps: { value: _vm.value[index] },
                  on: {
                    input: function (event) {
                      _vm.value[index] = event.target.value
                      _vm.change(_vm.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.multiple
                  ? _c("div", { staticClass: "go-input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn go-btn-icon",
                          attrs: { type: "button" },
                        },
                        [
                          index === _vm.value.length - 1
                            ? _c("i", {
                                staticClass: "go-icon-24 go-icon-plus",
                                on: { click: _vm.addValue },
                              })
                            : _c("i", {
                                staticClass: "go-icon-24 go-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeValue(index)
                                  },
                                },
                              }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "KEYWORD"
      ? _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "go-block-between" }, [
            _c("label", { staticClass: "go-form-label" }, [
              _vm._v(_vm._s(_vm.$t("scrap-agent.allow-access.keyword"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-input-multiple" },
            _vm._l(_vm.value, function (_, index) {
              return _c("div", { key: index, staticClass: "go-input-group" }, [
                _c("input", {
                  staticClass: "go-form-control",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t(
                      "scrap-agent.allow-access.keyword-placeholder"
                    ),
                  },
                  domProps: { value: _vm.value[index] },
                  on: {
                    input: function (event) {
                      _vm.value[index] = event.target.value
                      _vm.change(_vm.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.multiple
                  ? _c("div", { staticClass: "go-input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn go-btn-icon",
                          attrs: { type: "button" },
                        },
                        [
                          index === _vm.value.length - 1
                            ? _c("i", {
                                staticClass: "go-icon-24 go-icon-plus",
                                on: { click: _vm.addValue },
                              })
                            : _c("i", {
                                staticClass: "go-icon-24 go-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeValue(index)
                                  },
                                },
                              }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "URL"
      ? _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "go-block-between" }, [
            _c("label", { staticClass: "go-form-label" }, [
              _vm._v(_vm._s(_vm.$t("scrap-agent.allow-access.url"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-input-multiple" },
            _vm._l(_vm.value, function (_, index) {
              return _c("div", { key: index, staticClass: "go-input-group" }, [
                _c("input", {
                  staticClass: "go-form-control",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("scrap-agent.allow-access.url-pl"),
                  },
                  domProps: { value: _vm.value[index] },
                  on: {
                    input: function (event) {
                      _vm.value[index] = event.target.value
                      _vm.change(_vm.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.multiple
                  ? _c("div", { staticClass: "go-input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn go-btn-icon",
                          attrs: { type: "button" },
                        },
                        [
                          index === _vm.value.length - 1
                            ? _c("i", {
                                staticClass: "go-icon-24 go-icon-plus",
                                on: { click: _vm.addValue },
                              })
                            : _c("i", {
                                staticClass: "go-icon-24 go-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeValue(index)
                                  },
                                },
                              }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "TOPIC"
      ? _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "go-block-between" }, [
            _c("label", { staticClass: "go-form-label" }, [
              _vm._v(_vm._s(_vm.$t("scrap-agent.naver-blog.input-topic"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-input-multiple" },
            _vm._l(_vm.value, function (_, index) {
              return _c("div", { key: index, staticClass: "go-input-group" }, [
                _c("input", {
                  staticClass: "go-form-control",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("scrap-agent.naver-blog.topic-pl"),
                  },
                  domProps: { value: _vm.value[index] },
                  on: {
                    input: function (event) {
                      _vm.value[index] = event.target.value
                      _vm.change(_vm.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.multiple
                  ? _c("div", { staticClass: "go-input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn go-btn-icon",
                          attrs: { type: "button" },
                        },
                        [
                          index === _vm.value.length - 1
                            ? _c("i", {
                                staticClass: "go-icon-24 go-icon-plus",
                                on: { click: _vm.addValue },
                              })
                            : _c("i", {
                                staticClass: "go-icon-24 go-icon-close",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeValue(index)
                                  },
                                },
                              }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [
      _c("i", { staticClass: "go-icon-24 go-icon-home" }),
      _vm._v(" "),
      _c("span", [_vm._v("Inbox")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [
      _c("i", { staticClass: "go-icon-24 go-icon-home" }),
      _vm._v(" "),
      _c("span", [_vm._v("News Feed")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }